export const HOMEPAGE_DATA_REQUEST = 'HOMEPAGE_DATA_REQUEST'
export const HOMEPAGE_DATA_REQUEST_SUCCESS = 'HOMEPAGE_DATA_REQUEST_SUCCESS'
export const HOMEPAGE_DATA_REQUEST_FAIL = 'HOMEPAGE_DATA_REQUEST_FAIL'

export const ABOUT_DATA_REQUEST = 'ABOUT_DATA_REQUEST'
export const ABOUT_DATA_REQUEST_SUCCESS = 'ABOUT_DATA_REQUEST_SUCCESS'
export const ABOUT_DATA_REQUEST_FAIL = 'ABOUT_DATA_REQUEST_FAIL'


export const CONTACT_DATA_REQUEST = 'CONTACT_DATA_REQUEST'
export const CONTACT_DATA_REQUEST_SUCCESS = 'CONTACT_DATA_REQUEST_SUCCESS'
export const CONTACT_DATA_REQUEST_FAIL = 'CONTACT_DATA_REQUEST_FAIL'

export const CONTACT_REQUEST = 'CONTACT_REQUEST'
export const CONTACT_REQUEST_SUCCESS = 'CONTACT_REQUEST_SUCCESS'
export const CONTACT_REQUEST_FAIL = 'CONTACT_REQUEST_FAIL'